module.exports = __webpack_public_path__ + "img/图片4.22dd80b6.png";